const FacebookPrivacyLevel =
{
	CUSTOM:'CUSTOM',
	SELF:'SELF',
	ALL_FRIENDS:'ALL_FRIENDS',
	FRIENDS_OF_FRIENDS:'FRIENDS_OF_FRIENDS',
	EVERYONE:'EVERYONE'
}
export default FacebookPrivacyLevel;
